module.exports = __webpack_public_path__ + "static/media/about-title.8a833e46.png";